export const getEnumKeyByString = <T extends { [index: string]: string }>(
  enum_: T,
  enumKey: string,
): keyof T | undefined => Object.keys(enum_).find((key) => key == enumKey);
